import posthog from "posthog-js"

import { IS_PROD } from "@/lib/constants"

const projectToken = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN

// Only run analytics in production, matching the Sentry client config. Staging
// and local dev share this bundle, so the check is on the serving origin.
if (IS_PROD && projectToken) {
  posthog.init(projectToken, {
    // Managed reverse proxy on our own domain, so ingestion isn't blocked by
    // ad/tracker blockers that match posthog.com.
    api_host: "https://t.lumen.energy",
    // The proxy only fronts ingestion. Links out to the PostHog app (toolbar,
    // session replay) have to target the real UI host or they 404.
    ui_host: "https://us.posthog.com",
    defaults: "2026-05-30",
    // Already the SDK default; stated explicitly because it decides whether
    // anonymous visitors get person profiles, which is what we're billed on.
    person_profiles: "identified_only",
    capture_exceptions: true,
  })
}

export { posthog }
